/**
 *
 * InfoWindow
 *
 */

// import React from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Popup } from 'react-leaflet';
import { red500 } from 'styles/colors';

const InfoWindow = styled(Popup)`
  .leaflet-popup-content-wrapper {
    border-radius: 4px;
    padding: 5px 10px;
  }
  .leaflet-popup-content {
    margin: 0;
  }
  header {
    padding-right: 10px;
    padding-bottom: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid ${red500};
  }
  h2 {
    font-weight: bold;
    font-size: 1.2em;
  }
  h3 {
    font-weight: bold;
    font-size: 1.1em;
  }
  h2,
  h3,
  p {
    margin: 5px 0;
  }
`;

export default InfoWindow;
